import { __assign } from "tslib";
import * as React from 'react';
import { themes } from '../../ThemeOptions';
var BootStrapTfoot = React.lazy(function () {
    return import('../../bootstrap-table-components/components/BTTfoot');
});
var bootStrapTfoot = function (props) {
    return React.createElement(BootStrapTfoot, __assign({}, props));
};
export var Tfoot = function (props) {
    var componentToDisplay = bootStrapTfoot(props);
    switch (props.ioTheme.uiLibrary) {
        case 'bootstrap':
            componentToDisplay = bootStrapTfoot(props);
    }
    return React.createElement(React.Fragment, null, componentToDisplay);
};
Tfoot.defaultProps = {
    styleName: 'primary',
    ioTheme: themes[0],
    ioMode: 'light'
};
export default Tfoot;
//# sourceMappingURL=Tfoot.js.map